import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {Registration} from "../../models/registration";
import {ServiceCategory} from "../../models/service-category";
import Helpers from "../../utils/helpers";

@Injectable()
export class ServiceCategoryControllerService {

  private baseUrl: string = environment.BASE_URL;

  constructor(private http: HttpClient) {
  }

  public createCategory(serviceCategory: ServiceCategory): Observable<ServiceCategory> {
    Helpers.trimRecursiveObj(serviceCategory);
    const body = JSON.stringify(serviceCategory);
    return this.http.post(this.baseUrl + "/service_category", body) as  Observable<ServiceCategory>;
  }

  public deleteCategory(serviceCategoryId: string) {
    return this.http.delete(this.baseUrl + "service_category/" + serviceCategoryId, {responseType: "text"});
  }

  public updateCategory(serviceCategory: ServiceCategory) {
    const body = JSON.stringify(serviceCategory);
    return this.http.put(this.baseUrl + "service_category", body, {responseType: "text"});
  }

  public getAllServiceCategories(): Observable<ServiceCategory[]> {
    return this.http.get(this.baseUrl + "service_category") as  Observable<ServiceCategory[]>;
  }

  public getServiceCategories(serviceId: string): Observable<ServiceCategory[]> {
    return this.http.get(this.baseUrl + "service/" + serviceId + "/service_category") as  Observable<ServiceCategory[]>;
  }

  public updateServiceCategories(serviceId: string, serviceCategories: ServiceCategory[]) {
    Helpers.trimRecursiveObj(serviceCategories);
    const body = JSON.stringify(serviceCategories);
    return this.http.post(this.baseUrl + "service_categories/" + serviceId, body, {responseType: "text"});
  }
}
